import React, { useState } from "react";
import { IListing } from "../../lib/Listing/types";
import { EWsrvTransform } from "../../lib/Media/util";
import { ITabContent, TabbedContentBlade } from "../Blades/TabbedContentBlade";
import { ContactForm } from "../Forms";
import { ListingGallery } from "../Gallery/ListingGallery";
import { ListingCard, EListingCardLayouts } from "./ListingCard";
import { ListingContact } from "./ListingContact";
import ListingDetails, { EListingDetailsLayout } from "./ListingDetails";
import { ListingMap } from "./ListingMap";
import { ListingOpenHouse } from "./ListingOpenHouse";
import { ListingSummary } from "./ListingSummary";
import { EListingVitalsLayout, ListingVitals } from "./ListingVitals";
import { IListingLayoutProps } from "./util";
import { format } from "date-fns";
import ListingShare from "./ListingShare";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";

export const ListingLayoutVitalsAbove: React.FC<IListingLayoutProps> = ({
  listing,
  title,
  linkFunc,
  similar,
  agents,
  className = "",
  similarCardProps,
  vitalsProps,
  contactProps,
  summaryProps,
  galleryProps,
  detailsProps,
  formProps,
  mapProps,
  rowClassName = "",
  showContactUsForm,
  contactUsFormProps,
  displayDisclaimer = false,
  disclaimerCssClasses = "",
  disclaimers,
  displayMediaSection,
  photosTabTitle,
  propertyVideoTabTitle,
  virtualTourTabTitle,
  floorplansTabTitle,
  formColumnClassName = "",
  openHouseProps,
  showDivider = false,
  dividerClassName = "",
  listingShareProps,
}) => {
  let MediaSection: React.FC<IListing> = () => {
    return <></>;
  };
  displayMediaSection &&
    (MediaSection = (listing) => {
      if (listing.videos || listing.tours || listing.floorplans) {
        let tabContent: ITabContent[] = [
          {
            tabTitle: photosTabTitle ?? "Photos",
            contentClassName: "max-w-full",
            content: (
              <ListingGallery
                listing={listing}
                preset={EWsrvTransform.cover16x9}
                width={1600}
                height={900}
                {...galleryProps}
              />
            ),
          },
        ];
        if (listing.videos && listing.videos.length > 0) {
          tabContent.push({
            tabTitle: propertyVideoTabTitle ?? "Property Video",
            contentClassName: "max-w-full w-full",
            content: (
              <iframe
                src={listing.videos[0].url}
                allowFullScreen
                allow="encrypted-media"
                className="w-full aspect-video"
              />
            ),
          });
        }
        if (listing.tours && listing.tours.length > 0) {
          tabContent.push({
            tabTitle: virtualTourTabTitle ?? "Virtual Tour",
            contentClassName: "max-w-full w-full",
            content: (
              <iframe
                src={listing.tours[0].url}
                className="w-full aspect-video"
              />
            ),
          });
        }
        if (listing.floorplans && listing.floorplans.length > 0) {
          tabContent.push({
            tabTitle: floorplansTabTitle ?? "Floor Plans",
            content: (
              <>
                {listing.floorplans.map((plan, index) => (
                  <img src={plan.url} key={index} />
                ))}
              </>
            ),
          });
        }
        return (
          <TabbedContentBlade
            title="Media"
            className="max-w-screen-xl mx-auto"
            tabListClassName="inverted"
            tabs={tabContent}
          />
        );
      } else {
        return (
          <ListingGallery
            listing={listing}
            preset={EWsrvTransform.cover16x9}
            width={1600}
            height={900}
            {...galleryProps}
          />
        );
      }
    });

  const [isMapViewSelected, setIsMapViewSelected] = useState(true);

  const handleMapViewClick = () => {
    setIsMapViewSelected(true);
  };

  const handleStreetViewClick = () => {
    setIsMapViewSelected(false);
  };

  return (
    <div className={`${className} listing-layout layout-vitals-above`}>
      <div className=" flex flex-col vitals-column md:flex-row vitals-row md:justify-between px-[15px] lg:px-0">
        <div className="w-full md:w-1/2 justify-left font-bold vitals-address">
          <h1>{listing.address.street1}</h1>
          <h2>
            {listing.address.city}, {listing.address.state}{" "}
            {listing.address.postal}
          </h2>
        </div>
        <div className="text-left w-full md:w-1/2 xl:text-right vitals-icons !justify-start md:justify-end">
          <ListingVitals
            listing={listing}
            className="mb-3"
            {...vitalsProps}
            layout={EListingVitalsLayout.column1Border0}
            omitAddressParts={["city", "state", "postal"]}
            twoLineAddress={false}
            cityName={false}
            vitalIconsClassName="justify-start md:!justify-end !gap-1 md:ml-0 w-full"
            locationClassName="hidden"
            showFlags={true}
            priceClassName="price md:ml-0 text-left md:text-right grow w-full md:w-auto md:grow-0"
            replaceIconsForText={true}
          />
        </div>
      </div>
      <div
        className={`lg:grid lg:grid-cols-3 lg:space-x-5 my-5 ${rowClassName} listing-gallery !items-start`}
      >
        <div className="relative col-span-2">
          {listing.status && listing.status.toLowerCase() === "closed" && (
            <div className="absolute open-house-container py-2 top-2 left-0 items-center z-10 bg-red-600 text-white text-xs px-4 h-9 inline-block line-h-9">
              <span className="open-house-text">SOLD</span>{" "}
            </div>
          )}
          {!listing.status ||
            (listing.status &&
              listing.status.toLowerCase() !== "closed" &&
              listing.openHouse &&
              listing.openHouse.length > 0 && (
                <div className="absolute open-house-container py-2 top-2 left-0 items-center z-10 bg-blue-800 text-white text-xs font-semibold px-4 h-9 inline-block line-h-9">
                  <span className="open-house-text">
                    OPEN HOUSE{" "}
                    {format(
                      new Date(listing.openHouse[0].startDate),
                      "EEE, MMM dd, yyyy"
                    )}
                  </span>
                </div>
              ))}
          <ListingGallery
            listing={listing}
            preset={EWsrvTransform.cover3x2}
            width={900}
            height={600}
            className="lg:col-span-2 mb-3 relative z-1"
            showCaptions={false}
            customLeftNav={
              <div
                className="image-gallery-icon image-gallery-left-nav z-50
              "
              >
                <div className="arrow">
                  <FaArrowLeft className="text-white font-bold ml-[3px]" />
                </div>
              </div>
            }
            customRightNav={
              <div
                className="image-gallery-icon image-gallery-right-nav z-50 
            "
              >
                <div className="arrow ml-[-20px]">
                  <FaArrowRight className="text-white ml-[3px]" />
                </div>
              </div>
            }
            {...galleryProps}
          ></ListingGallery>
          <div className="flex flex-wrap listing-features gap-4 text-[14px] py-3 courtesy">
            <span>
              Listing Courtesy of{"\n"}
              <span>{listing.officeName}</span>
            </span>
          </div>
        </div>
        <div className={`lg:col-span-1 mb-3 ${formColumnClassName}`}>
          {showDivider && (
            <div className={`w-full h-px bg-divider ${dividerClassName}`}></div>
          )}
          {
            <ListingContact
              listing={listing}
              agents={agents}
              offices={listing.office}
              linkFunc={linkFunc}
              {...contactProps}
            />
          }
          <div className="form-share">
            <ContactForm
              {...formProps}
              fieldsetClassName="!my-0 !py-0"
              mainLegendClassName="!mt-4 !pt-4"
              inputTextAreaLabel="MESSAGE"
              inputTextAreaClassName="text-area"
              hideReCaptchaText={true}
            />
            <ListingShare
              className="mt-0 pt-0 text-xs pl-10"
              listingPageUrl={listing.path ?? ""}
              printPageUrl={listing.printPath}
              {...listingShareProps}
              showPrint={true}
            />
          </div>
        </div>
      </div>
      <div className="mx-auto text-center">
        <ListingSummary
          listing={listing}
          className="my-5 py-3 mx-auto"
          showCourtesy={false}
          {...summaryProps}
        />
      </div>
      <ListingOpenHouse
        openHouse={listing.openHouse}
        className="mb-3 text-center"
        {...openHouseProps}
      />
      {<MediaSection {...listing} />}
      {listing.details && (
        <div>
          <h1 className="pb-0">Details</h1>
          <ListingDetails
            layout={EListingDetailsLayout.groupNone}
            titleClassName="invisible"
            detailGroups={listing.details}
            className="py-3 !w-screen"
            {...detailsProps}
          />
        </div>
      )}

      {listing.location && listing.location?.lat && listing.location.lng && (
        <div>
          <h1 className="pt-[20px] pr-[15px] pb-[25px] pl-[15px] text-[42px]">
            Location
          </h1>
          <div className="text-center h-[70px] text-[18px]">
            <button
              onClick={handleMapViewClick}
              className={`${isMapViewSelected ? "underline-map" : "no-underline"
                } px-2 pb-1`}
            >
              MAP VIEW
            </button>
            <button
              onClick={handleStreetViewClick}
              className={`${!isMapViewSelected ? "underline-map" : "no-underline"
                } px-2 pb-1`}
            >
              STREET VIEW
            </button>
          </div>
          <ListingMap
            streetView={!isMapViewSelected}
            listing={listing}
            title="Location"
            className="my-5 py-3 !w-screen"
            {...mapProps}
          />
        </div>
      )}
      {similar && similar.length > 0 && (
        <div className="similar-properties ">
          <h1 className="first-similar-title pb-0">Similar</h1>
          <h2 className="second-similar-title text-center">PROPERTIES</h2>
          <div className="grid grid-cols-1 px-[15px] md:grid-cols-2 xl:grid-cols-3 gap-4">
            {similar.slice(0, 3).map((listing, index) => (
              <ListingCard
                key={index}
                layout={EListingCardLayouts.vertical}
                vitalsLayout={EListingVitalsLayout.column2Border1}
                listing={listing}
                linkImage={true}
                linkFunc={linkFunc}
                className="max-w-[680px]"
                maxWidthImage={680}
                vitalsTwoLineAddress={false}
                {...similarCardProps}
              />
            ))}
          </div>
        </div>
      )}
      {showContactUsForm && <ContactForm {...contactUsFormProps} />}
      {displayDisclaimer && (
        <section
          className={disclaimerCssClasses}
          dangerouslySetInnerHTML={{
            __html:
              disclaimers?.find(
                (x) => x.mlsSourceName === listing.mlsSourceName
              )?.disclaimerText ?? "",
          }}
        ></section>
      )}
    </div>
  );
};
